import React from 'react'

function TenderTextCrosstalk() {
    return (
        <embed src="\pdfs\EAT1.2.9_OG_Crosstalk-attenuation-air-transfer-element_kr.pdf" width="100%" height="2100px" />

    )
}

export default TenderTextCrosstalk